import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { notificationsAPI } from '../../services/api';

export const fetchNotifications = createAsyncThunk('notifications/fetchAll', async (params, { rejectWithValue }) => {
  try { const res = await notificationsAPI.list(params); return res.data; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed'); }
});

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: { items: [], unreadCount: 0, loading: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.items = action.payload.notifications; state.unreadCount = action.payload.unreadCount; state.loading = false;
      });
  },
});

export default notificationsSlice.reducer;
